// @ts-nocheck
import { useEffect, useState } from "react";
import { db } from "../db/db";
import { API_BASE_URL as BACKEND } from "../utils/api";

function resolveStaffId(rawId: any) {
  const candidate =
    rawId && typeof rawId === "object" && "id" in rawId ? rawId.id : rawId;

  if (candidate === undefined || candidate === null) {
    return null;
  }

  const numeric = parseInt(String(candidate).replace(/[^0-9-]/g, ""), 10);
  return Number.isNaN(numeric) ? null : numeric;
}

async function replaceTableContents(table: any, rows: any[]) {
  await db.transaction("rw", table, async () => {
    await table.clear();
    if (rows.length > 0) {
      await table.bulkAdd(rows);
    }
  });
}

function DataRetrieve({ id, refreshTick }: any) {
  const [visits, setVisits] = useState([]);
  const [carePlans, setCarePlans] = useState([]);
  const [allocatedShifts, setAllocatedShifts] = useState([]);
  const [contractedShifts, setContractedShifts] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [usernames, setUsernames] = useState([]);
  const [holidayList, setHolidayList] = useState([]);
  const [holidayStatus, setHolidayStatus] = useState([]);
  const [clients, setClients] = useState([]);
  const [training, setTraining] = useState([]);

  useEffect(() => {
    const userId =
      resolveStaffId(id) ?? resolveStaffId(localStorage.getItem("employeeId"));

    if (userId !== null) {
      fetch(`${BACKEND}/visits?id=${userId}`)
        .then((response) => response.json())
        .then((result) => setVisits(result))
        .catch((error) => console.error(error));
      fetch(`${BACKEND}/shifts/allocated?id=${userId}`)
        .then((response) => response.json())
        .then((result) => setAllocatedShifts(result))
        .catch((error) => console.error(error));
      fetch(`${BACKEND}/shifts/contracted?id=${userId}`)
        .then((response) => response.json())
        .then((result) => setContractedShifts(result))
        .catch((error) => console.error(error));
      fetch(`${BACKEND}/care-plan`)
        .then((response) => response.json())
        .then((result) => setCarePlans(result))
        .catch((error) => console.error(error));
      fetch(`${BACKEND}/tasks`)
        .then((response) => response.json())
        .then((result) => setTasks(result))
        .catch((error) => console.error(error));
      fetch(`${BACKEND}/usernames`)
        .then((response) => response.json())
        .then((result) => setUsernames(result));
      fetch(`${BACKEND}/holiday/list?id=${userId}`)
        .then((response) => response.json())
        .then((result) => setHolidayList(result))
        .catch((error) => console.error(error));
      fetch(`${BACKEND}/holiday?id=${userId}`)
        .then((response) => response.json())
        .then((result) => setHolidayStatus(result))
        .catch((error) => console.error(error));
      fetch(`${BACKEND}/clients?id=${userId}`)
        .then((response) => response.json())
        .then((result) => setClients(result))
        .catch((error) => console.error(error));
      fetch(`${BACKEND}/training?id=${userId}`)
        .then((response) => response.json())
        .then((result) => setTraining(result))
        .catch((error) => console.error(error));
    }
  }, [id, refreshTick]);

  useEffect(() => {
    if (visits.length > 0) {
      console.log(visits)
      const filteredVisits = visits.filter(
        (obj1, i, arr) => arr.findIndex((obj2) => obj2.id === obj1.id) === i,
      );
      replaceTableContents(db.visits, filteredVisits).catch((error) => {
        console.log(error);
      });
    }
  }, [visits]);

  useEffect(() => {
    if (usernames) {
      replaceTableContents(db.users, usernames).catch((error) => {
        console.log(error);
      });
    }
  }, [usernames]);

  useEffect(() => {
    if (carePlans) {
      replaceTableContents(db.carePlans, carePlans).catch((error) => {
        console.log(error);
      });
    }
  }, [carePlans]);

  useEffect(() => {
    if (allocatedShifts) {
      replaceTableContents(db.allocatedShifts, allocatedShifts).catch(
        (error) => {
          console.log(error);
        }
      );
    }
  }, [allocatedShifts]);

  useEffect(() => {
    if (contractedShifts) {
      replaceTableContents(db.contractedShifts, contractedShifts).catch(
        (error) => {
          console.log(error);
        }
      );
    }
  }, [contractedShifts]);
  useEffect(() => {
    if (tasks) {
      replaceTableContents(db.tasks, tasks).catch((error) => {
        console.log(error);
      });
    }
  }, [tasks]);

  useEffect(() => {
    if (holidayList) {
      replaceTableContents(db.holiday_list, holidayList).catch((error) => {
        console.log(error);
      });
    }
  }, [holidayList]);

  useEffect(() => {
    if (training) {
      replaceTableContents(db.training, training).catch((error) => {
        console.log(error);
      });
    }
  }, [training]);

  useEffect(() => {
    if (holidayStatus) {
      if (holidayStatus.length !== 0) {
        const data = { id: holidayStatus[0].id, status: holidayStatus };
        db.holiday_status.put(data).catch((error) => {
          console.log(error);
        });
      }
    }
  }, [holidayStatus]);

  useEffect(() => {
    if (clients) {
      // if (clients.length !== 0) {
      //   db.clients.clear()
        const correctedClients = clients.map((client) => {
          return {
            idc1_staff: client["idc1_staff"],
            ida1_client: client["ida1_client"],
            name: client["name"],
            location: client["home_sl_id"],
            has_acknowledged: client["has_acknowledged"],
            health: client["1_health"],
            independence: client["2_independence"],
            comms: client["3_comms"],
            relationships: client["4_relationships"],
            safety: client["5_safety"],
            what_can_be_improved: client["what_can_be_improved"],
            what_went_well: client["what_went_well"],
            date_of_advice: client["wk_com_date_of_advice"],
            image: client['clientphoto']
          };
        });
        replaceTableContents(db.clients, correctedClients).catch((error) => {
          console.log(error);
        });
      // }
    }
  }, [clients]);

  return <></>;
}
export default DataRetrieve;
